import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import React, { useEffect, useRef, useState } from 'react'
import { PdfGeneratorReports } from '../../../../../Helpers/pdfGeneratorReports'
import { GET_ONE_REPORT_BY_ID } from '../../../../../../graphql/Catalog/Reports/reports'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import moment from 'moment'
import { useQuery } from '@apollo/client'
import { objNameRoles } from '../../../../../../const/constRoles'
import { add } from 'lodash'
const API_KEY = process.env.REACT_APP_API_KEY_GOOGLE_MAPS

// Custom hook to manage checkbox states
const useFilters = (initialState) => {
  const [filters, setFilters] = useState(initialState)

  const toggleFilter = (filterName) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: !prev[filterName],
    }))
  }

  return [filters, toggleFilter]
}

const ModalReportPdf = ({
  reportId,
  title = '',
  filename,
  pageSize,
  pageOrientation,
}) => {
  //---------- Hooks ----------//
  const [data, setData] = useState({
    general: {
      category: {
        name: null,
        icon: null,
      },
      sub_category: {
        name: null,
        icon: null,
      },
      status: null,
      start_date: null,
      due_date: null,
      completed_at: null,
      planning_date: null,
      jurisiction: null,
      sub_juristiction: null,
      user_report: {
        type: null,
        name: null,
      },
      data_form_json: null,
    },
    address: {
      street: null,
      zipcode: null,
      state: null,
      city: null,
      reference: null,
      latitude: null,
      longitude: null,
    },
    user_report: {
      channel_capture: null,
      name: null,
      email: null,
      phone: null,
    },
    user_responsible: {
      name: null,
      email: null,
      charge: null,
    },
    attachments: [],
  })

  const [loading, setLoading] = useState(true)

  // Initialize filters hook
  const [filters, toggleFilter] = useFilters({
    generalData: true,
    location: true,
    requesterData: true,
    responsibleData: true,
    evidence: true,
  })
  // Initialize pages
  const [pages, togglePages] = useFilters({
    generalData: false,
    location: false,
    requesterData: false,
    responsibleData: false,
    evidence: false,
  })

  //---------- Query ----------//
  const {
    data: dataReport,
    loading: loadingReport,
    error: errorReport,
  } = useQuery(GET_ONE_REPORT_BY_ID, {
    variables: {
      reportId: parseInt(reportId),
    },
    fetchPolicy: 'no-cache',
  })

  //---------- UseEffect ----------//
  useEffect(() => {
    if (!loadingReport) {
      if (errorReport) {
        toastSweetAlert({
          mode: 'errorToast',
          message: 'Error al descargar el reporte',
        })
        return setLoading(false)
      }

      if (dataReport?.getOneReportById) {
        const dataRep = dataReport?.getOneReportById
        let uniqueUser = dataRep?.AttachmentsOfReport?.reduce(
          (acc, attachment) => {
            if (!acc.some((user) => user.user_id === attachment.user_id)) {
              acc.push({
                user_id: attachment.user_id,
                user: {
                  name: attachment.UserOfReportAttachment?.name,
                  rol: attachment.UserOfReportAttachment?.RoleOfUser?.role_name,
                },
              })
            }
            return acc
          },
          []
        )

        let attachments = []
        uniqueUser?.map(async (user) => {
          let findAttachment = dataRep?.AttachmentsOfReport.filter((value) => {
            return value?.user_id == user.user_id
          })
          if (findAttachment.length > 0) {
            let urls = []
            for (const attachment of findAttachment) {
              if (attachment.type_file === 'img' && attachment?.url) {
                urls.push(attachment.url)
              }
            }
            attachments.push({
              user: {
                name: user?.user?.name,
                rol: user?.user?.rol,
              },
              urls,
            })
          }
          return null
        })
        //`data:image/jpeg;base64,${btoa(url)}`

        let newDataFormJson = []
        if (JSON.parse(dataRep?.data_form_json)) {
          let dataFormJson = JSON.parse(dataRep?.data_form_json)

          typeof dataFormJson !== 'object' ||
            dataFormJson === null ||
            (!Array.isArray(dataFormJson) &&
              Object.entries(dataFormJson).map(([key, value]) => {
                newDataFormJson.push({
                  [key]: value,
                })
              }))
        }

        let url = null
        if (
          dataRep?.AddressOfReport?.latitude &&
          dataRep?.AddressOfReport?.longitude
        ) {
          const { latitude, longitude } = dataRep?.AddressOfReport
          url = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7C${latitude},${longitude}&key=${API_KEY}`
        }

        let cityzenData = {
          name: 'N/A',
          email: 'N/A',
          phone: 'N/A',
          address: 'N/A',
        }

        if (dataRep.channel_capture === 'tlajochat') {
          cityzenData.name = dataRep?.UserTlajoChatOfReport?.name || 'N/A'
          cityzenData.phone = dataRep?.UserTlajoChatOfReport?.phone || 'N/A'
          cityzenData.address = dataRep?.UserTlajoChatOfReport?.address || 'N/A'
        }

        if (dataRep.channel_capture === 'web') {
          cityzenData.name = dataRep?.ReportCitizenOfUsers?.name || 'N/A'
          cityzenData.phone = dataRep?.ReportCitizenOfUsers?.phone || 'N/A'
          cityzenData.address = dataRep?.ReportCitizenOfUsers?.address || 'N/A'
        }

        if (dataRep.channel_capture === 'web_gestor') {
          cityzenData.name = dataRep?.ReportToUsers?.name || 'N/A'
          cityzenData.email = dataRep?.ReportToUsers?.email || 'N/A'
          cityzenData.phone = dataRep?.ReportToUsers?.phone || 'N/A'
          cityzenData.address = dataRep?.ReportToUsers?.address || 'N/A'
        }

        if (dataRep.channel_capture === 'app') {
          cityzenData.name = dataRep?.ReportToUsers?.name || 'N/A'
          cityzenData.email = dataRep?.ReportToUsers?.email || 'N/A'
          cityzenData.phone = dataRep?.ReportToUsers?.phone || 'N/A'
          cityzenData.address = dataRep?.ReportToUsers?.address || 'N/A'
        }

        if (dataRep.channel_capture === 'web_anonymous') {
          cityzenData.name = dataRep?.ReportToUsers?.name || 'N/A'
          cityzenData.email = dataRep?.ReportToUsers?.email || 'N/A'
          cityzenData.phone = dataRep?.ReportToUsers?.phone || 'N/A'
          cityzenData.address = dataRep?.ReportToUsers?.address || 'N/A'
        }
        setData({
          general: {
            category: {
              name: dataRep?.ReportToGroupCategory?.name || 'N/A',
              icon: dataRep?.ReportToGroupCategory?.icon,
            },
            subcategory: {
              name: dataRep?.ReportToGroupCategorySub?.name || 'N/A',
              icon: dataRep?.ReportToGroupCategorySub?.icon,
            },
            status: dataRep?.StatusOfReport?.name,
            folio: dataRep?.folio,
            start_date: dataRep?.start_date
              ? `${moment(dataRep.start_date).format('DD/MM/YYYY')}, ${moment(
                  dataRep.start_date
                ).format('LT')}`
              : 'N/A',
            due_date: dataRep?.due_date
              ? `${moment(dataRep.due_date).format('DD/MM/YYYY')}, ${moment(
                  dataRep.due_date
                ).format('LT')}`
              : 'N/A',
            completed_at: dataRep?.completed_at
              ? `${moment(dataRep.completed_at).format('DD/MM/YYYY')}, ${moment(
                  dataRep.completed_at
                ).format('LT')}`
              : 'N/A',
            planning_date: dataRep?.planning_date
              ? `${moment(dataRep.planning_date).format(
                  'DD/MM/YYYY'
                )}, ${moment(dataRep.planning_date).format('LT')}`
              : 'N/A',
            jurisiction: dataRep?.JurisdictionOfReport?.name,
            sub_juristiction: dataRep?.JurisdictionsSubOfReport?.name || 'N/A',
            user_report: {
              type:
                dataRep?.ReportToUsers?.id_role ==
                  objNameRoles.gestor_interno ||
                dataRep?.ReportToUsers?.id_role ==
                  objNameRoles.gestor_global_independiente ||
                dataRep?.ReportToUsers?.id_role == objNameRoles.gestor_global
                  ? 'Comunicante interno'
                  : 'Ciudadano',
              name: cityzenData.name,
            },
            data_form_json: newDataFormJson,
          },
          address: {
            street: dataRep?.AddressOfReport?.street,
            zipcode: dataRep?.AddressOfReport?.zipcode,
            state: dataRep?.AddressOfReport?.state,
            city: dataRep?.AddressOfReport?.city,
            reference: dataRep?.AddressOfReport?.reference || 'N/A',
            latitude: dataRep?.AddressOfReport?.latitude,
            longitude: dataRep?.AddressOfReport?.longitude,
            address_full: dataRep?.AddressOfReport?.address_full,
            url,
          },
          user_report: {
            channel_capture: dataRep?.channel_capture,
            name: cityzenData.name,
            email: cityzenData.email,
            phone: cityzenData.phone,
            address: cityzenData.address,
          },
          user_responsible: {
            name: dataRep?.ReportsToResponsible?.name || 'N/A',
            email: dataRep?.ReportsToResponsible?.email || 'N/A',
            charge:
              dataRep?.ReportsToResponsible?.JobPositionOfUser?.name || 'N/A',
          },
          attachments,
        })
      }
      setLoading(false)
    } else setLoading(true)
  }, [dataReport, loadingReport, errorReport])

  const downloadLinkRef = useRef(null)

  /* useEffect(() => {
    const link = document.getElementById('vs1-report-export-link');
    if (!loading && downloadLinkRef.current && link) {
      
      setTimeout(() => {
        link.click();
      }, 1000);
    }
  }, [loading]); */

  return (
    <div className="modal-report-pdf row">
      <div className="modal-report-pdf__options col-4">
        <ul className="modal-report-pdf__options-list">
          <li className="modal-report-pdf__option">
            <label className="d-flex justify-content-start align-items-center">
              <div className="checkbox mr-2">
                <input
                  type="checkbox"
                  checked={filters.generalData}
                  onChange={() => toggleFilter('generalData')}
                />
              </div>
              <span>Datos generales</span>
            </label>
            <label class="checkboxPages ml-3">
              <input
                type="checkbox"
                checked={pages.generalData}
                onChange={() => togglePages('generalData')}
              />
              <span class="checkmark"></span>
              <span class="label ml-2">Nueva pagina</span>
            </label>
          </li>
          <li className="modal-report-pdf__option">
            <label className="d-flex justify-content-start align-items-center">
              <div className="checkbox mr-2">
                <input
                  type="checkbox"
                  checked={filters.location}
                  onChange={() => toggleFilter('location')}
                />
              </div>
              <span>Ubicación</span>
            </label>
            <label class="checkboxPages ml-3">
              <input
                type="checkbox"
                checked={pages.location}
                onChange={() => togglePages('location')}
              />
              <span class="checkmark"></span>
              <span class="label ml-2">Nueva pagina</span>
            </label>
          </li>
          <li className="modal-report-pdf__option">
            <label className="d-flex justify-content-start align-items-center">
              <div className="checkbox mr-2">
                <input
                  type="checkbox"
                  checked={filters.requesterData}
                  onChange={() => toggleFilter('requesterData')}
                />
              </div>
              <span>Datos del Solicitante</span>
            </label>
            <label class="checkboxPages ml-3">
              <input
                type="checkbox"
                checked={pages.requesterData}
                onChange={() => togglePages('requesterData')}
              />
              <span class="checkmark"></span>
              <span class="label ml-2">Nueva pagina</span>
            </label>
          </li>
          <li className="modal-report-pdf__option">
            <label className="d-flex justify-content-start align-items-center">
              <div className="checkbox mr-2">
                <input
                  type="checkbox"
                  checked={filters.responsibleData}
                  onChange={() => toggleFilter('responsibleData')}
                />
              </div>
              <span>Datos del Responsable</span>
            </label>
            <label class="checkboxPages ml-3">
              <input
                type="checkbox"
                checked={pages.responsibleData}
                onChange={() => togglePages('responsibleData')}
              />
              <span class="checkmark"></span>
              <span class="label ml-2">Nueva pagina</span>
            </label>
          </li>
          <li className="modal-report-pdf__option">
            <label className="d-flex justify-content-start align-items-center">
              <div className="checkbox mr-2">
                <input
                  type="checkbox"
                  checked={filters.evidence}
                  onChange={() => toggleFilter('evidence')}
                />
              </div>
              <span>Evidencias</span>
            </label>
            <label class="checkboxPages ml-3">
              <input
                type="checkbox"
                checked={pages.evidence}
                onChange={() => togglePages('evidence')}
              />
              <span class="checkmark"></span>
              <span class="label ml-2">Nueva pagina</span>
            </label>
          </li>
        </ul>
      </div>
      <div className="modal-report-pdf__render col-8">
        {loading ? (
          <div className="modal-report-pdf__loading">Cargando...</div>
        ) : (
          <>
            <PDFDownloadLink
              document={
                <PdfGeneratorReports
                  title={title}
                  pageSize={pageSize}
                  pageOrientation={pageOrientation}
                  data={data}
                  filters={filters}
                  pages={pages}
                />
              }
              fileName={`${filename}`}
              className="btn btn-transparent"
            >
              <span id="vs1-report-export-link" ref={downloadLinkRef}>
                Descargar PDF
              </span>
            </PDFDownloadLink>
            <PDFViewer
              className="vs1-pdf-viewer mt-2"
              showToolbar={false}
              children={
                <PdfGeneratorReports
                  title={title}
                  pageSize={pageSize}
                  pageOrientation={pageOrientation}
                  data={data}
                  filters={filters}
                  pages={pages}
                />
              }
            />
          </>
        )}
      </div>
    </div>
  )
}

export default ModalReportPdf
